import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';


@Component({
    selector: 'app-table-sort-icon',
    templateUrl: './table-sort-icon.component.html'
})

export class TableSortIconComponent implements OnInit, OnDestroy {

    @Input() property: string;
    @Input() sort$: Observable<any>;

    column;
    direction;

    private sub: Subscription;

    ngOnInit() { 
        this.sub = this.sort$.subscribe(data => {
            this.column = data.column;
            this.direction = data.direction;
        });
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}